import * as React from "react";
import type { SVGProps } from "react";
const SvgSliderArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={36}
    fill="none"
    {...props}
  >
    <path
      fill="#919196"
      d="M19.575 35.588a1.38 1.38 0 0 0 0-1.991L3.503 18 19.575 2.403a1.38 1.38 0 0 0 0-1.99 1.48 1.48 0 0 0-2.052 0L.425 17.004a1.38 1.38 0 0 0 0 1.99l17.098 16.593c.567.55 1.486.55 2.052 0"
    />
  </svg>
);
export default SvgSliderArrow;
